import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CategoryMaster = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  const businessName = localStorage.getItem("business_name") || "N/A";
  const defaultSearch = queryParams.get('business_id') || "";
  const [searchQuery, setSearchQuery] = useState(defaultSearch);
  const [categoryData, setCategoryData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;
  const warehouse_id = localStorage.getItem("warehouse_id");
const [showImageModal, setShowImageModal] = useState(false);
const [previewImage, setPreviewImage] = useState('');

  const tableHeaders = ["#", "Image", "Category", "Description",  "Status", "Action"];

  const [formData, setFormData] = useState({
    veemart_category_name: '',
    description: '',
    veemart_cat_image: '',
    active_status: 1,
    priority_order: '',
    veemart_business_id: localStorage.getItem('business_id') || 0,
    created_by: localStorage.getItem('user_id') || '',
        warehouse_id: warehouse_id,

  });

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchCategoryData();
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

 const fetchCategoryDataold = async () => {
                      const veemart_business_id= localStorage.getItem('business_id') ;


    try {
    const res = await axios.get(`${var_api}sa_veemart_category_master/get`);
      const data = Array.isArray(res.data)
        ? res.data
        : (res.data?.data || []);
        console.log("data", data);
      setCategoryData(data);
    } catch {
      toast.error("Failed to fetch category data");
      setCategoryData([]);
    }
  };
  const fetchCategoryData = async () => {
  const warehouse_id = localStorage.getItem("warehouse_id");

  try {
    const res = await axios.get(
      `${var_api}sa_veemart_category_master/getCategorybywarehouse/${warehouse_id}`
    );

    const data = Array.isArray(res.data)
      ? res.data
      : (res.data?.data || []);

    console.log("data", data);
    setCategoryData(data);

  } catch (err) {
    toast.error("Failed to fetch category data");
    setCategoryData([]);
  }
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleAddClick = () => {
    setFormData({
      veemart_category_name: '',
      description: '',
      veemart_cat_image: '',
      active_status: 1,
      priority_order: '',
      veemart_business_id: localStorage.getItem('business_id') ,
      created_by: localStorage.getItem('user_id') || '',
          warehouse_id: warehouse_id,

    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({
      ...item,
      veemart_business_id: localStorage.getItem('business_id') || '',
      created_by: localStorage.getItem('user_id') || ''
    });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.veemart_category_name.trim()) newErrors.veemart_category_name = "Category name is required";
    if (!formData.priority_order.toString().trim()) newErrors.priority_order = "Priority order is required";
    if (!isEditMode && !file) newErrors.veemart_cat_image = "Image is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      Object.entries(formData).forEach(([key, val]) => {
        if (key === 'veemart_cat_image' && file) return;
        form.append(key, val);
      });
      if (file) form.append('veemart_cat_image', file);

      const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
      const res = isEditMode && formData.id
        ? await axios.put(`${var_api}sa_veemart_category_master/update/${formData.id}`, form, headers)
        : await axios.post(`${var_api}sa_veemart_category_master/post`, form, headers);

      toast.success(res?.data?.message || "Saved successfully!", { autoClose: 2000 });
      setShowModal(false);
      fetchCategoryData();
      setFile(null);
      setFormData({
        veemart_category_name: '',
        description: '',
        veemart_cat_image: '',
        active_status: 1,
        priority_order: '',
        veemart_business_id: localStorage.getItem('business_id') || '',
        created_by: localStorage.getItem('user_id') || '',
            warehouse_id: warehouse_id,

      });
      setCurrentPage(1);

    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  const businessId = localStorage.getItem("business_id") || "";

  const filteredData = categoryData
    // .filter(item => String(item.veemart_business_id) === String(businessId))
    .filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between mb-3 align-items-center">
            <div>
              <div className="d-flex align-items-center gap-2">
                {/* <Button variant="light" onClick={handleBack} className="shadow-sm">
                  <i className="fas fa-arrow-left"></i>
                </Button> */}
                <h5 className="mb-0">
                  Category Master
                  {/* <strong>Business:</strong> <span style={{ color: 'blue' }}>{businessName}</span> */}
                </h5>
              </div>
            </div>
          </div>

          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search category..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                           <img
  src={item.veemart_cat_image ? `${image_api}${item.veemart_cat_image.replace(/^test\//, '')}` : defaultImg}
  alt="category"
  width="40"
  height="40"
  className="rounded"
  onClick={() => {
    setPreviewImage(`${image_api}${item.veemart_cat_image.replace(/^test\//, '')}`);
    setShowImageModal(true);
  }}
  style={{ cursor: 'pointer' }}
/>

                          </td>
                          <td>{item.veemart_category_name}</td>
                          <td>{item.description}</td>
                          {/* <td>{item.priority_order}</td> */}
                          <td>
                            <span className={`badge ${item.active_status === 1 || item.active_status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                              {item.active_status === 1 || item.active_status === 'Active' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td className="text-center">
                            <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              className="btn shadow btn-xs sharp"
                              style={{ backgroundColor: "#28a745", color: "white" }}
                              title="View Category Products"
                              onClick={() => {
                                localStorage.setItem("cat_id", item.id);
                                localStorage.setItem("cat_name", item.veemart_category_name);
                                navigate(`/vee-product?cat_id=${encodeURIComponent(item.id)}`);
                              }}
                            >
                              <i className="fas fa-cubes"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Category" : "Add Category"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Category  <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="veemart_category_name"
                      value={formData.veemart_category_name}
                      placeholder="Enter category name"
                      onChange={handleInputChange}
                    />
                    {errors.veemart_category_name && <div className="text-danger small mt-1">{errors.veemart_category_name}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={formData.description}
                      placeholder="Enter description"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image <span className="text-danger">*</span></Form.Label>
                    {isEditMode && formData.veemart_cat_image && !file && (
                      <div className="mb-2 d-flex gap-2 align-items-center">
                        <img
                          src={`${image_api}${formData.veemart_cat_image.replace(/^test\//, '')}`}
                          alt="Preview"
                          width="80"
                          className="rounded border"
                        />
                      </div>
                    )}
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const selectedFile = e.target.files[0];
                        setFile(selectedFile);
                        if (selectedFile) setErrors(prev => ({ ...prev, veemart_cat_image: '' }));
                      }}
                    />
                    {errors.veemart_cat_image && <div className="text-danger small mt-1">{errors.veemart_cat_image}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Priority Order<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="priority_order"
                      value={formData.priority_order}
                      onChange={handleInputChange}
                      min="0"
                      placeholder="Enter Priority Order"
                    />
                    {errors.priority_order && <div className="text-danger small">{errors.priority_order}</div>}
                  </Form.Group>
                </Col>

                {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Check
                        type="switch"
                        id="status-switch"
                        label={formData.active_status === 1 ? 'Active' : 'Inactive'}
                        checked={formData.active_status === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            active_status: e.target.checked ? 1 : 0,
                          })
                        }
                        className="form-switch"
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button variant={isEditMode ? "warning" : "secondary"} type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {isEditMode ? "Updating..." : "Creating..."}
                    </>
                  ) : (
                    isEditMode ? "Update" : "Create"
                  )}
                </Button>

                <Button
                  variant="danger"
                  onClick={() => {
                    if (isEditMode) setShowModal(false);
                    else {
                      setFormData({
                        veemart_category_name: '',
                        description: '',
                        veemart_cat_image: '',
                        active_status: 1,
                        priority_order: '',
                        veemart_business_id: localStorage.getItem('business_id') || '',
                        created_by: localStorage.getItem('user_id') || '',
                            warehouse_id: warehouse_id,

                      });
                    }
                  }}
                  disabled={loading}
                >
                  {isEditMode ? "Cancel" : "Reset"}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>
<Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="md">
  <Modal.Header closeButton>
    <Modal.Title>Image Preview</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    <img
      src={previewImage}
      alt="Preview"
      style={{ width: "100%", borderRadius: "10px" }}
      className="shadow"
    />
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowImageModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

      <ToastContainer />
      <style>{`
        .form-switch .form-check-input:checked {
          background-color: #28a745;
          border-color: #28a745;
        }
        .form-switch .form-check-input {
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default CategoryMaster;
